import { render, staticRenderFns } from "./NewPasswordStep.vue?vue&type=template&id=e73e24e0&"
import script from "./NewPasswordStep.vue?vue&type=script&lang=js&"
export * from "./NewPasswordStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports